import React, { useContext, useEffect, useRef, useState } from 'react'
import { createEvaluateSetting, queryEvaluateDetailSetting, queryEvaluateSetting, updateEvaluateSetting } from '../../../utility/service/importanceIdentification-service';
import { checkDpSuccess } from '../../../utility/service/tool-service';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';
import { MessageContext, handleSuccessMessage } from '../../../store/messageStore';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { FormInput } from '../../../components/FormInput';
import { FormTextarea } from '../../../components/FormTextarea';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SystemLoading,checkLoading } from '../../../store/loadingStore';
import PrimePanel from "../../../components/PrimePanel";

export const CusCritieriaItemComponent = ({
    register,
    errors,
    fieldName,
    inputCheckKeyDown,
    fields,
    handleResetForm,
    handleDelForm,
    index,
    action = "create",
    isReadOnly
}) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="grid">
                <div className="col-6">
                    <FormInput
                    labelText={t('criteria_remark')}
                    disabled={isReadOnly}
                    register={register}
                    errors={errors}
                    id={`${fieldName}.remark`}
                    type="text"
                    placeholder={t('criteria_remark')}
                    labelClass={`control-label required`}
                    rules={{ required: t('validation.required'), }}
                    enterClick={(e) => { inputCheckKeyDown(e) }}
                />
                </div>
                <div  className="col-5">
                    <FormInput
                    labelText={t('score')}
                    disabled={isReadOnly}
                    register={register}
                    errors={errors}
                    id={`${fieldName}.evaluationValue`}
                    type="number"
                    placeholder={t('score')}
                    labelClass={`control-label required`}
                    rules={{ required: t('validation.required'), }}
                    enterClick={(e) => { inputCheckKeyDown(e) }}
                />
                </div>
                <div className="col-1 flex align-items-center justify-content-center">
                    <button type="button" className="icon-btn"
                    onClick={() => { fields?.length === 1 ? handleResetForm(index) : handleDelForm(index) }}>
                    <i className='pi pi-minus'></i>
                </button>
                </div>
                
            </div>
        </>
    )
}

export const EvaluationCriteriaSetting = ({setCloseDialog = () => { },}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { itemObj, setItemObj, setAction, action } = useOutletContext();
    const [evaluateSettingList, setEvaluateSettingList] = useState([]);
    const [, dispatch] = useContext(MessageContext); //訊息視窗  
    const refSetting = useRef();
    const [,loading] = useContext(SystemLoading);

    //表單驗證
    const registerOptions = {
        evaluateIdName: { required: t('validation.required') },
        remark: { required: t('validation.required') },
    }

    const {
        register,
        handleSubmit,
        resetField,
        reset,
        watch,
        getValues,
        setValue,
        clearErrors,
        control,
        formState: { errors, isValid }
    } = useForm({
        defaultValues: {
            criteriaRadio: 'addCriteria'
        },
        //錯誤驗證時機
        mode: 'all'
    });

    const { fields: evalSettingFields, append: addSettingForm, remove: delSettingForm, insert: insertSettingForm } = useFieldArray({
        control,
        name: "evaluateSettingDList",
    })

    const watchCriteriaRadio = watch("criteriaRadio");

    useEffect(() => {
        if (watchCriteriaRadio === 'existCriteria') {
            setValue("evaluateSettingDList", [{ remark: '' }]);
            initFormData();
        } else {
            setValue("evaluationId", "");
            setValue("evaluateSettingDList", [{ remark: '' }]);
            initFormData();
        }
    }, [watchCriteriaRadio]);

    const initFormData = () => {
        setValue("evaluateIdName", "");
        setValue("remark", "");
        clearErrors();
    }


    const checkKeyDown = (e) => {
        // if (e.key === 'Enter') e.preventDefault();
        if (e.keyCode === 13) {
            e.stopPropagation();
        }
    };

    const inputCheckKeyDown = (e) => { //避免觸發 按enter 後 就觸發 onSubmit 事件冒泡 給input 使用 <FormInput enterClick事件 ; 一般input onKeyDown事件
        if (e.key === 'Enter') {
            e.preventDefault();

        }
    }

    const handleResetForm = (index) => {
        delSettingForm(index);
        addSettingForm({ evaluationId: '' });
        clearErrors();
    }

    const handleDelForm = (index, length) => {
        if (length > 1) {
            delSettingForm(index);
        } else {
            delSettingForm(index);
            addSettingForm({ evaluationId: '' });
        }
    }

    useEffect(() => {
        axios_queryEvaluateSetting();
    }, [])

    const axios_queryEvaluateSetting = () => { //評估標準清單查詢
        queryEvaluateSetting({ companySeq: itemObj?.companySeq, useCase: "E" })
            .then((res) => {
                if (checkDpSuccess(res)) {
                    setEvaluateSettingList(res?.data?.RespBody?.evaluations?.options)

                }
            });
    }
    const axios_queryEvaluateDetailSetting = (evaluationId) => {
        queryEvaluateDetailSetting({ evaluationId })
            .then((res) => {
                if (checkDpSuccess(res)) {
                    let data = res?.data?.RespBody;
                    setValue("evaluateIdName", data?.evaluateIdName);
                    setValue("remark", data?.remark);
                    let dList = data?.evaluateSettingDList;

                    setValue("evaluateSettingDList", dList)

                }
            })
    }

    const onSubmit = (data) => {
        checkLoading(loading);
        let reqBody = {
            evaluateIdName: data.evaluateIdName,
            remark: data.remark,
            evaluationType: 'S'
        }
        let evalSetting = []
        if (data.evaluateSettingDList?.length > 0) {
            evalSetting = data.evaluateSettingDList?.map((item, index) => {
                return {
                    evaluateIdName: item.remark,
                    remark: item.remark,
                    evaluationType: 'O',
                    evaluationValue: item.evaluationValue,
                    evaluationId: item?.evaluationId || null

                }
            })
            reqBody.evaluateSettingDList = evalSetting;
        }

        if (data.evaluationId !== '') { //update
            reqBody.evaluationId = data.evaluationId
            updateEvaluateSetting(reqBody)
                .then((res) => {
                    if (checkDpSuccess(res)) {
                        handleSuccessMessage(dispatch, t('button.update') + ' ' + t('message.success'));
                        axios_queryEvaluateSetting();
                    }
                })
                .finally((fin)=>{
                    checkLoading(loading,false);
                })
        } else {
            createEvaluateSetting(reqBody)
                .then((res) => {
                    if (checkDpSuccess(res)) {
                        handleSuccessMessage(dispatch, t('button.create') + ' ' + t('message.success'));
                        axios_queryEvaluateSetting();
                        setValue("evaluationId", "");
                        setValue("evaluateSettingDList", [{ remark: '' }]);
                        initFormData();
                    }
                })
                .finally((fin)=>{
                    checkLoading(loading,false);
                })
}


    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
                <div className="col-12 grid">
                    <div className="col-12">
                        <label
                            htmlFor="placeName"
                            className="control-label">
                            {t('evaluation_criteria')}
                        </label>
                    </div>

                    <Controller
                        name="criteriaRadio"
                        control={control}
                        rules={{ required: 'Value is required.' }}
                        render={({ field }) => (
                            <>
                                <div className="col-12 flex flex-wrap gap-2 align-items-center">
                                    <RadioButton inputId="addCriteria"
                                        {...field}
                                        inputRef={field.ref}
                                        value="addCriteria"
                                        checked={field.value === "addCriteria"} />
                                    <label htmlFor="addCriteria" className="mx-2">{t('add_criteria')}</label>
                                    <RadioButton inputId="existCriteria"
                                        {...field}
                                        inputRef={field.ref}
                                        value="existCriteria"
                                        checked={field.value === "existCriteria"} />
                                    <label htmlFor="existCriteria" className="mx-2">{t('existing_criteria')}</label>
                                {
                                    watchCriteriaRadio === 'existCriteria' && (
                                            <Controller
                                                name="evaluationId"
                                                control={control}
                                                render={({ field, fieldState }) => (
                                                    <Dropdown
                                                        filter
                                                        appendTo={"self"}
                                                        optionLabel="label"
                                                        optionValue="value"
                                                        value={field.value}
                                                        virtualScrollerOptions={{ itemSize: 40 }}
                                                        defaultValue={""}
                                                        placeholder={t("plz_chs")}
                                                        name="evaluationId"
                                                        control={control}
                                                        options={evaluateSettingList}
                                                        className={`w-6 ` + classNames({ "p-invalid": fieldState.error })}
                                                        onChange={(event) => {
                                                            field.onChange(event.value);
                                                            axios_queryEvaluateDetailSetting(event.value);
                                                        }}
                                                    />
                                                )}
                                            />
                                    )
                                }
                                </div>

                            </>
                        )}
                    />

                    <div className="col-12 lg:col-12">
                        <FormInput
                            register={register}
                            errors={errors}
                            id="evaluateIdName"
                            name="evaluateIdName"
                            type="text"
                            labelClass="required"
                            rules={registerOptions.evaluateIdName}
                            labelText={t("evaluationTemplateName")}
                        />
                    </div>

                    <div className="col-12 lg:col-12">
                        <FormTextarea
                            register={register}
                            errors={errors}
                            id="remark"
                            name="remark"
                            type="text"
                            labelText={t('criteria_remark')}
                            labelClass="required"
                            rules={registerOptions.remark}
                            areaClass="w-full"
                        />
                    </div>

                    <div className="col-12">
                        <PrimePanel 
                            toggleable 
                            className='evaluation-temp-setting-panel'
                            header={t('items')} 
                        >
                            {
                                evalSettingFields?.map((Field, index) => {
                                    return (
                                        <CusCritieriaItemComponent
                                            key={Field.id}
                                            evaluateSettingList={evaluateSettingList}
                                            register={register}
                                            errors={errors}
                                            fieldName={`evaluateSettingDList.${index}`}
                                            inputCheckKeyDown={inputCheckKeyDown}
                                            fields={evalSettingFields}
                                            handleResetForm={handleResetForm}
                                            handleDelForm={() => { handleDelForm(index, evalSettingFields?.length) }}
                                            index={index}
                                            action={action}
                                            control={control}
                                            isReadOnly={false}
                                        />
                                    )
                                })
                            }
                            <div className="form-group">
                                <button type="button" className="icon-btn"
                                    onClick={() => { addSettingForm({ evaluationId: '' }); }}>
                                    <i className='pi pi-plus'></i>
                                </button>
                            </div>
                        </PrimePanel>
                    </div>
                </div>
                <div className="col-12 gap-2 flex-all-center">
                    <Button disabled={!isValid} type="submit" label={t("button.confirm")} size="small" />
                    <Button type="button" outlined size="small" label={t("button.cancel")} onClick={(e) => {
                        e.preventDefault();
                        clearErrors();
                        setCloseDialog(false);
                    }} />


                </div>

            </form>

        </>
    )
}
